import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-sm font-medium leading-none text-text-primary peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
